import * as types from './constants';

// Get Sendbird Batch Messages
export const getSendbirdBatchMessagesRequest = data => (
  { type: types.GET_SENDBIRD_BATCH_MESSAGES_REQUEST, payload: data }
);

export const getSendbirdBatchMessagesDone = data => (
  { type: types.GET_SENDBIRD_BATCH_MESSAGES_DONE, payload: data }
);

export const getSendbirdBatchMessagesFailed = errors => (
  { type: types.GET_SENDBIRD_BATCH_MESSAGES_FAILED, payload: errors }
);

export const getSendbirdBatchMessagesReset = () => (
  { type: types.GET_SENDBIRD_BATCH_MESSAGES_RESET }
);

// Operations
export const sendbirdBatchMessagesSetPage = data => (
  { type: types.SENDBIRD_BATCH_MESSAGES_SET_PAGE, payload: data }
);